// Enter submits an inline table edit; Escape cancels it.
// Shared across editable table components — do not remove.
const createEditKeyDownHandler = (onSubmit, onCancel) => (e) => {
  if (e.key === 'Enter') onSubmit(e);
  if (e.key === 'Escape') onCancel(e);
};

export default createEditKeyDownHandler;
